'use client'

import { createContext } from 'react'

import type { UseActionFlowResponse } from './ActionFlowProvider'

/**
 * Value of the enclosing `ActionFlowProvider`; read it with `useActionFlow()`.
 * Consumers must not provide their own value. A subtree may only re-provide the current
 * `useActionFlow()` value with fields overridden (for example a wrapped `execute`).
 */
export const ActionFlowContext = createContext<UseActionFlowResponse | null>(null)
